import firebase from "firebase/app";
import { convertAssetUrl } from "src/api/asset";

const server_url = process.env.REACT_APP_SERVER_URL;

export const openAsset = async (blobUrl) => {
  // Public container (langsung buka)
  if (
    blobUrl?.includes(`/${process.env.REACT_APP_STORAGE_CONTAINER}/`)
  ) {
    window.open(blobUrl, "_blank");
    return;
  }
  // Non-private / non-blob URLs (already-signed /assets links, external URLs):
  // open directly — keeps the click gesture and avoids a pointless convert call.
  if (!blobUrl || typeof blobUrl !== "string" || !blobUrl.includes("blob.core")) {
    window.open(blobUrl, "_blank");
    return;
  }

  // Open the tab synchronously (inside the click) so the popup blocker doesn't kill it
  const win = window.open("", "_blank");

  try {
    const firebaseUser = firebase.auth().currentUser;
    const token = await firebaseUser.getIdToken();

    const response = await convertAssetUrl(token, { url: blobUrl });

    if (response.status !== 200) {
      throw new Error("Failed to convert asset");
    }

    const assetUrl = response.data.url.startsWith("http")
      ? response.data.url
      : `${server_url}${response.data.url}`;

    if (win) win.location.href = assetUrl;      // redirect the tab we already opened
    else window.location.href = assetUrl;
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};
